import * as React from 'react';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import StarIcon from '@mui/icons-material/Star';
import ListAltIcon from '@mui/icons-material/ListAlt';
import Logout from '@mui/icons-material/Logout';
import CloseIcon from '@mui/icons-material/Close';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import { useTheme, useMediaQuery } from '@mui/material';
import { $isAuth, setIsAuth } from '../../store/isAuthStore';
import Cookies from 'universal-cookie';
import { useUnit } from 'effector-react';

export const MenuElement = (props) => {
    const { anchor, setAnchor } = props;
    const open = Boolean(anchor);

    const isAuth = useUnit($isAuth);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleClose = () => {
        setAnchor(null);
    };

    const goToCompletedBiddings = () => {
        window.location.href = "/completedBiddings";
    };

    const goToRules = () => {
        window.location.href = "/Rules";
    };

    const logout = () => {
        setIsAuth(false);
        const cookies = new Cookies();
        cookies.remove("token");
        window.location.href = "/";
    }

    const goToOrders = () => {
        if (!isAuth) {
            window.location.href = `/authorization?returnUrl=${window.location.pathname}`;
            return;
        }
    }

    const goToFavoritesLots = () => {
        if (!isAuth) {
            window.location.href = `/authorization?returnUrl=${window.location.pathname}`;
            return;
        }
    }

    // Стили для полноэкранного меню на мобильных устройствах
    const mobileMenuStyles = {
        '& .MuiPaper-root': {
            width: '100vw',
            height: '100vh',
            maxHeight: '100vh',
            maxWidth: '100vw',
            margin: 0,
            top: '0 !important',
            left: '0 !important',
            right: 0,
            bottom: 0,
            borderRadius: 0,
            backgroundColor: theme.palette.background.paper
        },
        '& .MuiList-root': {
            paddingTop: '20px',
            paddingBottom: '20px',
        },
        '& .MuiMenuItem-root': {
            padding: '16px 24px',
            fontSize: '1.1rem',
        },
        '& .MuiListItemIcon-root': {
            minWidth: '40px',
        },
        '&::before': {
            display: 'none',
        }
    };

    // Стили для десктопного меню
    const desktopMenuStyles = {
        '& .MuiPaper-root': {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: -5.5,
            ml: -1,
            maxHeight: 'calc(100vh - 100px)',
            overflowY: "auto",
            '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                bottom: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
            },
        },
    };

    return (
        <React.Fragment>
            <Menu
                anchorEl={anchor}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                slotProps={{
                    paper: isMobile ? {
                        elevation: 0,
                        sx: mobileMenuStyles['& .MuiPaper-root']
                    } : {
                        elevation: 0,
                        sx: desktopMenuStyles['& .MuiPaper-root']
                    },
                }}
                sx={isMobile ? mobileMenuStyles : {}}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                // Для мобильных: растягиваем меню на весь экран
                {...(isMobile && {
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'right',
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'right',
                    },
                })}
            >
                {isMobile && (
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        padding: '5px 20px',
                        borderBottom: `1px solid ${theme.palette.divider}`,
                        fontSize: '20px',
                        fontWeight: 600,
                        color: '#333',
                    }}>
                        <h3>
                            Меню
                        </h3>
                        <IconButton
                            onClick={handleClose}
                            size="small"
                            sx={{ ml: 2 }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                )}
                <MenuItem onClick={goToCompletedBiddings}>
                    <ListItemIcon>
                        <ListAltIcon fontSize="small" />
                    </ListItemIcon>
                    Завершенные торги
                </MenuItem>
                <MenuItem onClick={goToOrders}>
                    <ListItemIcon>
                        <AssignmentTurnedInIcon fontSize="small" />
                    </ListItemIcon>
                    Заказы
                </MenuItem>

                <MenuItem onClick={goToFavoritesLots}>
                    <ListItemIcon>
                        <StarIcon fontSize="small" />
                    </ListItemIcon>
                    Избранные лоты
                </MenuItem>

                <Divider />

                <MenuItem onClick={goToRules}>
                    <ListItemIcon>
                        <AssignmentLateIcon fontSize="small" />
                    </ListItemIcon>
                    Правила
                </MenuItem>

                {isAuth &&
                    <Divider />
                }

                {isAuth &&

                    <MenuItem onClick={() => logout()}>
                        <ListItemIcon>
                            <Logout fontSize="small" />
                        </ListItemIcon>
                        Выход
                    </MenuItem>
                }

                {isMobile && <Box sx={{ height: '20px' }} />}
            </Menu>
        </React.Fragment>
    )
}